import { createSlice } from '@reduxjs/toolkit';

const loaderSlice = createSlice({
  name: 'loader',
  initialState: {
    loading: false,
    count: 0,
  },
  reducers: {
    showLoader: (state) => {
      state.count++;
      state.loading = true;
    },
    hideLoader: (state) => {
      state.count--;
      if (state.count <= 0) {
        state.loading = false;
        state.count = 0;
      }
    },
    resetLoader: (state) => {
      state.loading = false;
      state.count = 0;
    },
  },
});

export const { showLoader, hideLoader, resetLoader } = loaderSlice.actions;
export default loaderSlice.reducer;
